app.Application = (
    function () {
        var application = {
            Initialize: function () {
                app.Application.Index();
                app.Application.EvaluateAndHireCandidate();
                app.Application.AppDataCopy();
                app.RatingCommentHistoryModal.Init();
                app.RememberedCandidates.CandidateInfo();
                app.Document.Application();
            },
            Index: function () {
                app.RememberedCandidates.Index();
                app.Application.InitCriminalBackgroundFunctionality();
                $(document).on("component-bind-edit-mode-complete",
                    function () {
                        app.Application.InitCriminalBackgroundFunctionality();
                        app.Application.initTextAreaWithLimit();

                    });

                $(document).on("component-bind-edit-mode-complete-Documents",
                    function () {
                        $("[data-button-role='clear-documents']").on("click",
                            function () {
                                $("[data-button-role='document']").prop("checked", false);
                            });
                    });

                $(document).on("component-remove-complete-QuestionSetQuestion",
                    function (e, i) {
                        // when a question answer is removed, refresh the questions component
                        var appQuestionAnswerId = i.id;

                        var data = {
                            "id": appQuestionAnswerId
                        };

                        var url = "/Application/QuestionAnswerHasDuplicates";
                        $.ajax({
                            type: "POST",
                            url: url,
                            data: data,
                            success: function (d) {
                                if (!d.hasDuplicates) {
                                    //only remove alerts for duplicates if there aren't any
                                    var questionId = d.questionId;
                                    $("[data-questionid='" + questionId + "']").each(function () {
                                        $(this).attr("hidden", true);
                                    });

                                }
                            },
                            error: function (d) {
                                toastr.error("Something went wrong. Please refresh the page and try again.");
                            }
                        });
                    });

                $(document).on("component-save-complete component-bind-edit-mode-complete document-selected component-remove-complete",
                    function () {
                        //Refresh the checklist
                        var appId = {
                            "applicationId": $("#ApplicationId").val()
                        };
                        var url = "/Application/ChecklistViewForApplication";
                        $.ajax({
                            type: "POST",
                            url: url,
                            data: appId,
                            success: function (data) {
                                $("#theChecklistHtml").html(data);

                                if ($('#IsComplete').val() === 'True') {
                                    //Enable apply button
                                    $('#applyButton').prop("disabled", false);
                                    $('#applyButton').removeClass("disabled");
                                    $('#submitNotice').hide();
                                }
                                else {
                                    //disable apply button
                                    $('#applyButton').prop("disabled", true);
                                    $('#applyButton').addClass("disabled");
                                    $('#submitNotice').show();

                                }
                            },
                            error: function (data) {
                            }
                        });
                    });

                $("[data-question-set-id]").on("click", function () {
                    replaceSpinnerWithContent("#answerLookupResultsDiv", "")

                    var data = { questionSetId: $(this).data("question-set-id"), TargetApplicationId: $("#Id").val() };
                    //AJAX Call

                    replaceContentWithSpinner("#applicationSelectionDiv");
                    $.post("/Application/GetApplicationsForQuestionSetId", data, function (html) {
                        //put html in the div
                        replaceSpinnerWithContent("#applicationSelectionDiv", html);
                        //reassign on change fucnitonality to dropdown
                        assignOnChangeToAppDropdown();

                    })
                        .fail(function () {
                            toastr.error("Something went wrong, please try again.");
                        });

                    $('#questionCopyModal').modal();
                });

                function assignOnChangeToAppDropdown() {
                    $("[name='SelectedAnswersApplicationId']").on("change", function () {

                        if ($(this).val() !== null && $(this).val() != 'undefined' && $(this).val() != '') {

                            var data = {
                                SelectedApp: $(this).val(),
                                TargetApplicationId: $("#Id").val(),
                                QuestionSetId: $(this).data("question-set-id")
                            };

                            replaceContentWithSpinner("#answerLookupResultsDiv");

                            $.post("/Application/GetAnswersForApplication", data, function (html) {

                                //put html in the div
                                replaceSpinnerWithContent("#answerLookupResultsDiv", html);

                                //assign copy button functinality when view drops
                                $("[data-copy-answers-button]").on("click", function () {

                                    if (confirm("Copying questions will reload this page. Please make sure to save any unsaved work before proceeding. Click \"Ok\" to conitnue. ") == true) {
                                        var data = $(this).closest("form").serialize();

                                        replaceContentWithSpinner("#answerLookupResultsDiv");

                                        $.post("/Application/CopyAnswersToApplication", data, function (data) {

                                            //refresh component
                                            location.reload();

                                            toastr.success("Successfully copied questions to this applicaiton.");
                                        })
                                            .fail(function () {
                                                toastr.error("Something went wrong, please try again.");
                                            });
                                    }

                                });

                            })
                                .fail(function () {
                                    toastr.error("Something went wrong, please try again.");
                                });
                        }
                        else {
                            replaceSpinnerWithContent("#answerLookupResultsDiv", "")
                        }
                    });
                }

                function replaceContentWithSpinner(id) {
                    $(id).html(null);
                    $(id).addClass("loading-placeholder");
                }

                function replaceSpinnerWithContent(id, html) {
                    $(id).removeClass("loading-placeholder");
                    $(id).html(html);
                }

            },
            EvaluateAndHireCandidate: function () {
                $("form").on("submit", function () {
                    $(this).find(":submit").prop("disabled", true);
                });
            },
            InitCriminalBackgroundFunctionality: function () {
                showHideCriminalBackgroundDiv();
                //Assign functionality to show/hide criminal charges stuff
                $("input[name='HasPleadGuilty'], input[name='HasPendingCharges']").on("change",
                    function () {
                        showHideCriminalBackgroundDiv();
                    });

                function showHideCriminalBackgroundDiv() {
                    if ($("input[name='HasPendingCharges']:checked").val() === "True" ||
                        $("input[name='HasPleadGuilty']:checked").val() === "True") {
                        $("#ExplanationDiv").show();
                    } else {
                        $("#ExplanationDiv").hide();
                    }
                }
            },
            initTextAreaWithLimit: function (editComponent) {
                //This was modeled after the app.input.js string length character counter named the same. It was customized to handle the excluded characters
                //From the  custom string length attribute
                //setup the UI by adding HTML below element.
                $("textarea[data-val-stringlengthignorecharacters-maxcount]", editComponent).each(function () {
                    var uniqueId = app.Page.prototype.getGuid();
                    $(this).data('char-count-target', uniqueId);
                    $(this).after('<div id="' + uniqueId + '" class="text-limit-display">Character Count: 0</div>');
                });

                $("textarea[data-val-stringlengthignorecharacters-maxcount]", editComponent).on("keyup change input paste",
                    function (ev) {
                        var $tar = $(ev.target);

                        //grab data-charactercount-limit. Default to 500 if it is not defined
                        var charactersAllowed = parseInt($tar.data("val-stringlengthignorecharacters-maxcount") || 500, 10);
                        var theString = this.value;
                        var originalCount = theString.length;
                        //Get the excluded characters
                        var excludedCharacters = $tar.data("val-stringlengthignorecharacters-excludedcharacters").split(",");

                        //clean the characters out of the string
                        for (var i = 0; i < excludedCharacters.length; i++) {
                            theString = theString.replaceAll(excludedCharacters[i], "");

                        }
                        var characterCount = theString.length;

                        var difference = originalCount - characterCount;

                        if (characterCount > charactersAllowed) {
                            $(this).val($(this).val().substring(0, charactersAllowed + difference));
                            $('#' + $tar.data("char-count-target")).text("0 characters left");
                        } else {
                            $('#' + $tar.data("char-count-target"))
                                .text((charactersAllowed - characterCount) + " characters left");
                        }
                    }).keyup();
            },
            AppDataCopy: function () {
                var loadingHtml =
                    '<div class="modal-header>' +
                    'Do not exit page!' +
                    '</div>' +
                    '<div class="modal-body>' +
                    '<p style="font-size: xx-large; text-align:center">' +
                    '<strong>' +
                    '<i class="fa fa-exclamation-circle" aria-hidden="true" style="color: red"></i>' +
                    ' WARNING ' +
                    '<i class="fa fa-exclamation-circle" aria-hidden="true" style="color: red"></i>' +
                    '</strong>' +
                    '</p>' +
                    '<div>' +
                    '<div class="col-sm-12">' +
                    '<div class="d-flex align-items-center justify-content-center" style="height: 200px;"><img src="/Content/Images/Icons/loading.gif" /></div>' +
                    '<div class="alert alert-danger">' +
                    '<p class="text-center">Copying your application data... do not exit this page until the process is complete!</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';

                $("#confirmCopyModal").on("show.bs.modal",
                    function () {
                        $(window).on("beforeunload", function () {
                            return "Are you absolutely sure you want to leave this page?";
                        });
                        var returnUrl = $("#returnUrl").val();
                        var successUrl = "/Application/CopyDataSuccess?ReturnUrl=" + returnUrl
                        $("#btnCopyApplicationData").on("click",
                            function () {

                                var appId = $("#Id").val();

                                if (appId === null || appId === 0) {
                                    toastr.error("There was an error with your application id. Please refresh the page and try again.");
                                    return;
                                }

                                var url = "/Application/CopyApplicationData/" + appId;

                                //util.console.log("url: " + url);

                                //replace the modal with a spinner to show that it's loading
                                $(".modal-content").html(loadingHtml);

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    data: null,
                                    success: function (data) {

                                        $(window).off("beforeunload"); //remove beforeunload handler
                                        window.location.href = successUrl;
                                    },
                                    error: function (data) {
                                        //util.console.log(data);
                                        toastr.error("Failure");
                                    }
                                });
                            });

                        $("#btnCopyStandardApplicationData").on("click",
                            function () {

                                var appType = $("#ApplicationType").val();
                                var isCertified = appType.indexOf("Certified") >= 0;
                                var url = "/Application/CopyStandardApplicationData";

                                //util.console.log("url: " + url);

                                //replace the modal with a spinner to show that it's loading
                                $(".modal-content").html(loadingHtml);

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    data: { isCertified: isCertified },
                                    success: function (data) {

                                        $(window).off("beforeunload"); //remove beforeunload handler
                                        window.location.href = successUrl;
                                    },
                                    error: function (data) {
                                        //util.console.log(data);
                                        toastr.error("Failure");
                                    }
                                });
                            });

                        $("#btnCopyExistingStandardApplicationData").on("click",
                            function () {

                                var appType = $("#ApplicationType").val();
                                var isCertified = appType.indexOf("Certified") >= 0;
                                var url = "/Application/CopyExistingStandardApplicationData";

                                //util.console.log("url: " + url);

                                //replace the modal with a spinner to show that it's loading
                                $(".modal-content").html(loadingHtml);

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    data: { isCertified: isCertified },
                                    success: function (data) {

                                        $(window).off("beforeunload"); //remove beforeunload handler
                                        window.location.href = successUrl;
                                    },
                                    error: function (data) {
                                        //util.console.log(data);
                                        toastr.error("Failure");
                                    }
                                });
                            });
                    });

                $("#confirmCopyModal").on("hide.bs.modal", function () {
                    $(window).off("beforeunload");
                    $("#btnCopyApplicationData").off();
                    $("#btnCopyStandardApplicationData").off();
                });

            },
            Success: function () {
                history.pushState(null, document.title, location.href);
                window.addEventListener("popstate", function (event) {
                    history.pushState(null, document.title, location.href);
                });
            },
            Internal: function () {
                //Select all input elements with class 'code-input'
                const inputs = document.querySelectorAll('.code-input');
                const form = document.querySelector("form[name='code-form']");
                const errorMessage = document.getElementById('consolidated-error-message');

                //Function to validate only the code inputs
                function validateCodeInputs() {
                    let isValid = true;

                    //Check each input field to ensure they are not empty
                    inputs.forEach(input => {
                        if (input.value.trim() === '') {
                            isValid = false;
                        }
                    });

                    return isValid;
                }

                //Form submit handler for client-side validation only
                form.addEventListener('submit', function (event) {
                    const isFormValid = validateCodeInputs();

                    if (!isFormValid) {
                        //Prevent form submission if any code input is empty and show a single error message
                        event.preventDefault();
                        //Show consolidated error message
                        errorMessage.style.display = 'block';
                        //Clear individual validation messages
                        inputs.forEach(input => input.setCustomValidity(''));
                    } else {
                        //Hide error message if all inputs are valid
                        errorMessage.style.display = 'none';
                    }
                });

                //Hide the error message when user starts typing in any of the code inputs
                inputs.forEach(input => {
                    input.addEventListener('input', function () {
                        //Hide consolidated error message
                        errorMessage.style.display = 'none';
                        //Clear custom validity for each input
                        input.setCustomValidity('');
                    });
                });

                //Add event listeners for each input element
                inputs.forEach((input, index) => {
                    //On input event
                    input.addEventListener('input', (event) => {
                        //Allow only digits (0-9)
                        event.target.value = event.target.value.replace(/[^0-9]/g, '');

                        //Automatically move to the next input field
                        if (event.target.value.length === 1 && index < inputs.length - 1) {
                            inputs[index + 1].focus();
                        }
                    });

                    //On keydown event
                    input.addEventListener('keydown', (event) => {
                        //Check if the Enter key is pressed
                        if (event.key === 'Enter') {
                            return;  //Allow form submission
                        }
                        //Move to the previous input if backspace is pressed on an empty field
                        if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
                            inputs[index - 1].focus();
                        }
                    });

                    //On keypress event to restrict invalid characters
                    input.addEventListener('keypress', (event) => {
                        if (event.key === 'Enter') {
                            return;  //Allow form submission
                        }
                        //Prevent any character that is not a digit (0-9)
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    });

                    //On paste event
                    input.addEventListener('paste', (event) => {
                        //Get the pasted data
                        const pasteData = event.clipboardData.getData('text').replace(/[^0-9]/g, '');

                        //If the pasted data length matches the number of inputs, split and distribute the values
                        if (pasteData.length === inputs.length) {
                            for (let i = 0; i < inputs.length; i++) {
                                inputs[i].value = pasteData.charAt(i);
                            }
                            //Prevent the default paste action
                            event.preventDefault();
                            //Focus the last input to complete the paste action
                            inputs[inputs.length - 1].focus();
                        }
                    });
                });
            }
        }
        return application;
    }()
);